/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Roomannouncementreached2Inputs */

const en_roomannouncementreached2 = /** @type {(inputs: Roomannouncementreached2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reached: ${i?.count}`)
};

const de_roomannouncementreached2 = /** @type {(inputs: Roomannouncementreached2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erreicht: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Reached: {count}" |
*
* @param {Roomannouncementreached2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const roomannouncementreached2 = /** @type {((inputs: Roomannouncementreached2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Roomannouncementreached2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_roomannouncementreached2(inputs)
	return de_roomannouncementreached2(inputs)
});
export { roomannouncementreached2 as "roomAnnouncementReached" }